export default {
  dbl_sql_table: 'Table',
  dbl_sql_add_select: 'Select',
  dbl_sql_add_sql: 'SQL',
  dbl_sql_add_edit_sql: 'Edit SQL',
  dbl_sql_add_database: 'Database',
  dbl_sql_add_schema: 'Schema',
  dbl_sql_add_dataset: 'DataSet',
  dbl_sql_add_search_dataset: 'Search table or field',
  dbl_sql_add_search_schema: 'Search Schema', 
  dbl_sql_add_search_database: 'Search Database',
  dbl_sql_add_run: 'Run',
  dbl_sql_add_preview: 'Table Previews',
  dbl_sql_add_format: 'Format Alignment',
  dbl_sql_add_grammar_detection: 'Grammar Detection',
  dbl_sql_add_clear: 'Clear',
  dbl_sql_add_result: 'Result',
  dbl_sql_add_success_msg: 'information',
  dbl_sql_add_failed_msg: 'information',
  dbl_sql_edit_placeholder: "Please enter the SQL query here. For example, 'SELECT * From table_name'"
};